// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__b5Jek","inner":"page_inner__N3oyP","latest-articles-carousel":"page_latest-articles-carousel__VxFsW"};